import { useEffect } from "react";
import { Link, withRouter } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";

import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import Loader from "../../Components/Common/Loader";
import ProfileHeaderCard from "../../Components/Common/ProfileHeaderCard";
import ProfileInfoSection from "../../Components/Common/ProfileInfoSection";
import { useUser } from "../../hooks/useUser";
import { getStoredAuthUserId } from "../../utils/authUser";

const ProfilePage = (props) => {
  const { t } = props;

  const userId = getStoredAuthUserId();
  const userQ = useUser(userId);

  useEffect(() => {
    document.title = t("Profil | Le Conseiller du BTP");
  }, [t]);

  const error = userQ.error;
  const errorMessage =
    typeof error === "string" ? error : error?.message || "Erreur";

  if (!userId) return <Loader error={t("Utilisateur non connecté")} />;
  if (userQ.isLoading) return <Loader />;
  if (userQ.isError) {
    return (
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t("Profil")} pageTitle={t("Profil")} />
          <div className="alert alert-danger" role="alert">
            {errorMessage}
          </div>
          <Link to={`/pages-profile/${userId}`} className="btn btn-warning">
            <i className="ri-edit-box-line align-bottom"></i> {t("Modifier")}
          </Link>
        </Container>
      </div>
    );
  }

  const user = userQ.data || {};
  const profile = user.profile || {};
  const displayName =
    `${profile.first_name || ""} ${profile.last_name || ""}`.trim() ||
    user.username;

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title={t("Profil")} pageTitle={t("Profil")} />

        <ProfileHeaderCard
          t={t}
          picture={profile.profile_pic}
          name={displayName}
          subtitle={user.email || ""}
          phone={user.phone_number || ""}
          badge={profile.user_type || ""}
          actionNode={
            <Link to={`/pages-profile/${userId}`} className="btn btn-warning">
              <i className="ri-edit-box-line align-bottom"></i> {t("Modifier")}
            </Link>
          }
        />

        <Row>
          <Col lg={6}>
            <ProfileInfoSection
              title={t("Identité")}
              emptyFallback={t("(Non Renseigné)")}
              className="h-100"
              items={[
                { label: `${t("Identifiant")} :`, value: user.username },
                { label: `${t("Prénom")} :`, value: profile.first_name },
                { label: `${t("Nom")} :`, value: profile.last_name },
              ]}
            />
          </Col>
          <Col lg={6}>
            <ProfileInfoSection
              title={t("Contact")}
              emptyFallback={t("(Non Renseigné)")}
              className="h-100"
              items={[
                { label: `${t("Email")} :`, value: user.email },
                { label: `${t("Téléphone")} :`, value: user.phone_number },
                { label: `${t("Adresse")} :`, value: profile.address },
              ]}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

ProfilePage.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(ProfilePage));
